// extracted by mini-css-extract-plugin
export default {"file-tag":"styles_file-tag__VKxCS"};